module.exports = __webpack_public_path__ + "static/media/matching-sm.00e06fe3.gif";